import basketStore from '@shared/store/basket'

import useIncentive from '@shared/hooks/useIncentive'

import { getNextRoute } from '@dvp/helpers/Route'
import { ROUTE_NAME } from '@shared/config/constants'

// HOOKS
const { incentives } = useIncentive()

export default [
  {
    beforeEnter: (to, _from) => {
      const selectedQuiz = incentives.value.find(i => i.id === to.params?.quizId)
      if (!selectedQuiz) {
        return {
          name: getNextRoute(basketStore.basket),
        }
      }
    },
    path: 'quiz/:quizId',
    meta: {
      headerDisabled: true,
      navigation: false,
    },
    children: [
      {
        path: '',
        name: ROUTE_NAME.QUIZ,
        component: () => import('@shared/modules/Dvp/screens/Quiz/ScreenGame.vue'),
        props: true,
      },
      {
        beforeEnter: (_to, from) => {
          if (from.name !== ROUTE_NAME.QUIZ) {
            return {
              name: getNextRoute(basketStore.basket),
            }
          }
        },
        path: 'form',
        name: ROUTE_NAME.QUIZ_FORM,
        component: () => import('@shared/modules/Dvp/screens/Quiz/ScreenForm.vue'),
        props: true,
      },
      {
        beforeEnter: (_to, from) => {
          if (from.name !== ROUTE_NAME.QUIZ_FORM) {
            return {
              name: getNextRoute(basketStore.basket),
            }
          }
        },
        path: 'success',
        name: ROUTE_NAME.QUIZ_SUCCESS,
        component: () => import('@shared/modules/Dvp/screens/Quiz/ScreenSuccess.vue'),
      },
    ],
  },
]
